import { createSelector } from '@ngrx/store';
import { selectItemsByMysid } from '../item/item.reducer';
import { NewRelationsFeature } from '../new-relations/new-relations.reducer';

// Constants for mysid values used in task form
export const TASK_FORM_MYSID = {
  ALL_CONTACTS: 'relations_view_institutions',
  DEAL_CONTACTS: 'task_form_deal_contacts',
  ORIGINATIONS_DEALS: 'task_form_originations_deals',
  /** Used to fetch a single deal by id when related deal is not in assignee's list. */
  RELATED_DEAL_LOOKUP: 'task_form_related_deal_lookup',
} as const;

// Selectors for task form data
export const selectTaskFormAllContacts = createSelector(
  NewRelationsFeature.selectContactsByMysid(TASK_FORM_MYSID.ALL_CONTACTS),
  contacts => contacts || []
);

export const selectTaskFormDeals = createSelector(
  selectItemsByMysid(TASK_FORM_MYSID.ORIGINATIONS_DEALS),
  deals => deals || []
);
